import React from "react";
import { useNavigate } from "react-router-dom";
import ChartComponent from "../Components/AssessmentChart";
import { toast } from "react-toastify";

const AssessmentBox = ({
  id,
  title,
  status,
  score,
  total,
  percentage,
  percentageColor,
  chartId,
  icon,
  trendIcon,
  score_history,
  assessmentId
}) => {
  const navigate = useNavigate();
  // If score is null/undefined, don't render the box
  if (
    score === null ||
    score === undefined ||
    total === null ||
    total === undefined
  ) {
    return null;
  }



  return (
    <div className="col-md-6 col-lg-6 col-xl-4">
      <div className="assessment-card">
        <div className="assessment-card-top">
          <div className="assessment-type">
            <img
              src={icon}
              style={{ width: "45px", height: "45px" }}
              alt={`${title} icon`}
            />
            <div className="assessment-type-details">
              <h1
                className="mb-0"
                style={{
                  textTransform: "capitalize",
                  textAlign: "center",
                }}
                title={title}
              >
                {/* {title.length > 16 ? `${title.substring(0, 16)}...` : title} */}
                {title}
              </h1>{" "}
              <h3 className="text-body-b2 mb-0" style={{ color: "#c8ced3" }}>
                Current Score{" "}
                <span className="text-heading-h3" style={{ color: "#e6ecf1" }}>
                  {score}/{total}
                </span>
              </h3>
            </div>
            <button
              className={`btn-3 btn-1-primary `}
              onClick={() => {
                status === 'In Progress'
                ? navigate("/assessment-view", { state: { id : id, incomplete_id: assessmentId, assessment_status: 'not-completed' } })
                : navigate("/assessment-view", { state: { id } });
              }}
            >
              {status}
            </button>
          </div>
        </div>
        <div className="assessment-card-bottom">
          <div className="assessment-chart-container">
            <div className="chart-header">
              <h1
                className="text-small-s2 mb-0"
                style={{ color: "var(--Text-100, #d0d8df)" }}
              >
                Results History
              </h1>
              <div className="d-flex align-items-center" style={{ gap: "6px" }}>
                <img src={trendIcon} alt="chart trend" />

                <h3
                  className="text-caption-c2 mb-0"
                  style={{ color: percentageColor }}
                >
                  +{percentage}%
                </h3>
              </div>
            </div>
            {/* <div className="chart-canvas-container">
              <canvas
                id={chartId}
                // id="power-chart"
                style={{ width: "100%", height: "100%" }}
              ></canvas>
            </div> */}
            <ChartComponent
              chartId={chartId}
              score_history={score_history}
              total={total}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default AssessmentBox;
